import { render, staticRenderFns } from "./LoginWebDraft.vue?vue&type=template&id=40fcd728"
import script from "./LoginWebDraft.vue?vue&type=script&lang=js"
export * from "./LoginWebDraft.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports